import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
import StepProgress from "../../components/StepProgress";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

function PlannerWithoutTopics() {
  const { id, category } = useParams();
  const navigate = useNavigate();

  const [toggle, setToggle] = useState({ key: "", status: false });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({ status: false });
    } else {
      setToggle({ status: true, key });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);
  const [datanew, setDatanew] = useState([]);
  const [plans, setPlans] = useState([]);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(null);
  const [bookingLoading, setBookingLoading] = useState(false);
   const [topics, setTopics] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };
  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort");
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };
  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort");
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };
  const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort");
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error fetching course categories:", error);
    }
  };

  const [language, setLanguage] = useState("en");
  // fetch topics on mount
  useEffect(() => {
    if (!category) return;
    const fetchTopics = async () => {
      try {
        const resp = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrotopics-by-category/${encodeURIComponent(category)}`
        );
        setTopics(resp.data || []);
      } catch (err) {
        console.error("Error fetching topics:", err);
      }
    };

    fetchTopics();
  }, [category]);

  useEffect(() => {
    if (!id) return;
    const fetchAstrologerDetails = async () => {
      try {
        const response = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrologer/${id}`
        );
        setDatanew(response.data);
      } catch (error) {
        console.error("Error fetching astrologer details:", error);
      }
    };
    fetchAstrologerDetails();
  }, [id]);

  useEffect(() => {
    if (!id || !category) return;
    const fetchPlans = async () => {
      try {
        const resp = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/astroplans/${encodeURIComponent(
            id
          )}/${encodeURIComponent(category)}`
        );
        const normalized = (resp.data || []).map((p) => ({
          ...p,
          Mint: parseInt(p.Mint ?? 0, 10),
          Maxt: parseInt(p.Maxt ?? 0, 10),
          totalPrice: Number(p.totalPrice ?? 0),
        }));
        // setPlans(normalized);
        setPlans(normalized.slice(0, 1));
      } catch (err) {
        console.error("Error fetching plans:", err);
      }
    };
    fetchPlans();
  }, [id, category]);

  const handleBook = async (plan) => {
    setBookingError(null);
    setBookingSuccess(null);

    const userId = localStorage.getItem("userId");
    if (!userId) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);
      navigate("/login");
      return;
    }

    setBookingLoading(true);
    try {
      const payload = {
  astrologerId: id,
  category,
  planId: plan.planId ?? null,
  totalPrice: Number(plan.totalPrice ?? 0),
   customerName: `Plan ${plan.totalPrice}`,
  topics: [], // No topics needed
  userId,
  isWithoutTopics: true, // ✅ tells backend to allow empty topics
};

      const resp = await axios.post(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/bookings",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (resp?.data?.success && resp?.data?.bookingId) {
        const bookingId = resp.data.bookingId;
        setBookingSuccess("Booking created successfully. Redirecting…");
        setTimeout(() => navigate(`/scheduler/${bookingId}`), 800);
      } else {
        setBookingError(resp?.data?.message || "Unexpected server response.");
      }
    } catch (err) {
      console.error("Booking error:", err);
      setBookingError(
        err?.response?.data?.message || err.message || "Failed to create booking."
      );
    } finally {
      setBookingLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Available Plans - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>

      {/* Mobile Navigation */}
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>

          <div
            className="header-customize-item button"
            style={{
              padding: "0px 0px",
              background: "none",
              backgroundColor: "#14a077",
              borderRadius: "4px",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              color: "white",
            }}
          >
            <Link to="/astroservices" style={{ color: "#ffffff" }}>
              Consult Now
            </Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>
        </div>
      </div>

      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumb title="Review Available Plans" />

      <section
        className="testimonials-category-section"
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h5 style={{ fontSize: "22px" }}>{datanew.Named}</h5>
              <p style={{ fontStyle: "italic", maxWidth: "650px", margin: "auto" }}>
                <span
                  style={{
                    color: "#14A078",
                    fontWeight: "bold",
                    fontSize: "17px",
                    fontStyle: "normal",
                  }}
                >
                  {category} Expert
                </span>
              </p>
              <StepProgress activeStep={1} />
              {bookingError && <div style={{ color: "#b22222", marginTop: 8 }}>{bookingError}</div>}
              {bookingSuccess && <div style={{ color: "#14a077", marginTop: 8 }}>{bookingSuccess}</div>}
            </div>

            <div className="col-md-10" style={{ margin: "auto", marginTop:"20px" }}>
              <div className="row">
                  <div className="col-lg-8 col-md-8 col-12">

                     <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>
                    Astrology Topics
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "13px" }}>Use the following datalist to view topics covered in this eConsultation package.</span>
                  </p>

<style>{`
  .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
`}</style>
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "15px",
  }}
>
  <span>English</span>

  <label className="switch">
    <input
      type="checkbox"
      checked={language === "hi"}
      onChange={(e) => setLanguage(e.target.checked ? "hi" : "en")}
    />
    <span className="slider"></span>
  </label>

  <span>हिन्दी</span>
</div>
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid #ddd",
                        marginBottom: "20px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f8f8f8" }}>
                         
                         <th style={{ textAlign: "left", padding: "10px" }}>
  {language === "hi" ? "ज्योतिष विषय" : "Astrology Topics"}
</th>

<th style={{ textAlign: "left", padding: "10px" }}>
  {language === "hi" ? "संक्षिप्त विवरण" : "Quick Description"}
</th>
                        </tr>
                      </thead>
                      <tbody>
                        {topics.map((topic) => {
                        
                          return (
                            <tr key={topic.Id} style={{ borderBottom: "1px solid #eee" }}>
                          
                             <td style={{ padding: "8px", fontWeight: "600" }}>
  {language === "hi" ? topic.Named2 : topic.Named}
</td>

<td style={{ padding: "8px", color: "#555" }}>
  {language === "hi"
    ? (topic.Qdesc2 || "विवरण उपलब्ध नहीं है")
    : (topic.Qdesc || "No description available")}
</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>
                    Available Astrologer Plans
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "13px" }}>Continue to book a session with selected astrologer.</span>
                  </p>

                  {plans.length > 0 ? (
                    plans.map((plan) => (
                      <div
                        key={plan.planId}
                        style={{
                          width: "100%",
                          borderRadius: "12px",
                          background: "#fff",
                          border: "1px solid #e6e6e6",
                          padding: "16px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: 12,
                          }}
                        >
                          <div>
                            <h6 style={{ fontWeight: "900", marginBottom: "8px" }}>
                              Plan {plan.totalPrice}
                            </h6>
                              {/* <p style={{ margin: "4px 0", color: "#555" }}>
                                <strong>Max. Topics covered:</strong> {plan.Maxt ?? "N/A"}
                              </p> */}
                          </div>
                        </div>

                        <div style={{ marginTop: 8 }}>
                          <p
                            style={{
                              margin: "10px 0 0",
                              color: "#14a077",
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            Total: ₹{Number(plan.totalPrice ?? 0).toFixed(2)}
                          </p>
                          <p style={{ color: "#000", fontSize: "13px", fontWeight: 500 }}>
                            (Inclusive of all taxes)
                          </p>

                          <button
                            type="button"
                            onClick={() => handleBook(plan)}
                            disabled={bookingLoading}
                            style={{
                             padding: "12px 31px",
    border: "1px solid #14a077",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    borderRadius: "4px",
    display: "block",
    color: "rgb(255, 255, 255)",
    backgroundColor: "#14a077",
    textTransform: "none",
    marginTop: "15px",
    width: "100%",
                            }}
                          >
                            {bookingLoading
                              ? "Processing…"
                              : "Next: Select a Time Slot"}
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "#666", margin:"auto", textAlign:"center" }}>No plans available for this category.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Gotop />
    </>
  );
}

export default PlannerWithoutTopics;